import * as React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import Link from '@mui/material/Link';
import CardMedia from '@mui/material/CardMedia';
import { returnFilterText, stringToReactElement, statusLabel } from '../Utils.js';
// import PropTypes from 'prop-types';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	'& .MuiDialogContent-root': {
		padding: theme.spacing(2),
	},
	'& .MuiDialogActions-root': {
		padding: theme.spacing(1),
	},
}));

const BootstrapDialogTitle = (props) => {
	const { children, onClose, ...other } = props;

	return (
		<DialogTitle sx={{ m: 0, p: 2 }} {...other}>
			{children}
			{onClose ? (
				<IconButton
					aria-label="close"
					onClick={onClose}
					sx={{
						position: 'absolute',
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}
				>
					<CloseIcon />
				</IconButton>
			) : null}
		</DialogTitle>
	);
};


// BootstrapDialogTitle.propTypes = {
// 	children: PropTypes.node,
// 	onClose: PropTypes.func.isRequired,
//   };
  

export default function SearchCardDialog({ isOpen, onClose, item }) {
	// console.log("item", item);
	if (typeof(item) === "undefined") {
		return <></>
	}


	const shippingmethod = item.shipment.split(",");

	return (
		<BootstrapDialog
			onClose={onClose}
			aria-labelledby="customized-dialog-title"
			open={isOpen}
			className="bootstrapdialog"
			key={item.id}
		>
			<BootstrapDialogTitle id="customized-dialog-title" onClose={onClose}>
				{item.group} 
				{statusLabel(item.status)}
			</BootstrapDialogTitle>
			<DialogContent dividers className='dialogcontent'>
				{item.infoimage &&
					<><CardMedia component="img" image={item.infoimage} alt={item.group} className="defualtImage" /><br /></>
				} 
				<Typography gutterBottom className='cardcontentgrouptitle'>款式口味</Typography>
				<div className='cardcontentgroupbody'>
					{item.productlist ? <Typography variant="body1" gutterBottom component="div" ><ul>{item.productlist.split(",").map(x => (<li key={x}>{stringToReactElement(x)}</li>))}</ul></Typography> : "?"}
					{item.productinfo && <Typography variant="body1" gutterBottom >{stringToReactElement(item.productinfo)}</Typography>}
					{item.price && <Typography variant="body1" gutterBottom>{"價格範圍 : " + stringToReactElement(item.price)}</Typography>}
				</div>
				<Divider />
				<Typography gutterBottom className='cardcontentgrouptitle'>購買資訊</Typography>
				<div className='cardcontentgroupbody'>
					<Typography variant="body1" gutterBottom>發售日期 :  {item.timeslot_order ? stringToReactElement(item.timeslot_order) : "未有相關資訊"}</Typography>
					{item.orderlink ? <Typography variant="body1" gutterBottom><Link target="_blank" href={item.orderlink} >訂購連結</Link></Typography> : ""}
					{item.officialwebsite ? <Typography variant="body1" gutterBottom>{item.officialwebsite.split(",").map((x, i) => (<Link target="_blank" key={i} href={x}>官方網站</Link>))}</Typography> : ""}
					{(!item.orderlink && !item.officialwebsite) ? "未有相關連結" : ""}
				</div>
				<Divider />
				<Typography gutterBottom className='cardcontentgrouptitle'>取貨方式</Typography>
				<div className='cardcontentgroupbody'>
					<Typography variant="body1" component={'div'}  gutterBottom>取貨日期 : {item.deliveryperiod ? stringToReactElement(item.deliveryperiod) : "未有相關資訊"}</Typography>
					{
						shippingmethod.indexOf("merchant") > -1 &&
						(<>
							<Typography variant="body1" gutterBottom>{returnFilterText("shipment", "merchant")}</Typography>
							{item.shipment_merchant && <Typography variant="body1" gutterBottom>{stringToReactElement(item.shipment_merchant)}</Typography>}
							{item.shipment_merchant_location && <Typography variant="body1" gutterBottom component="div"><ul>{item.shipment_merchant_location.split(",").map(x => (<li key={x}>{stringToReactElement(x)}</li>))}</ul></Typography>}
						</>)
					}
					{
						shippingmethod.indexOf("delivery") > -1 &&
						(<>
							<Typography variant="body1" gutterBottom>{returnFilterText("shipment", "delivery")}</Typography>
							<Typography variant="body1" gutterBottom>{stringToReactElement(item.shipment_delivery)}</Typography>
							{item.shipment_delivery_method && <Typography variant="body1" gutterBottom component="div"><ul>{item.shipment_delivery_method.split(",").map(x => (<li key={x}>{stringToReactElement(x)}</li>))}</ul></Typography>}
						</>)
					}
					{shippingmethod.length === 0 && "未有資訊"}
				</div>
				<Divider />
				<Typography gutterBottom className='cardcontentgrouptitle'>社交媒體</Typography>
				<div className='cardcontentgroupbody'>
					<Typography variant="body1" gutterBottom><FacebookIcon className='icon_facebook' />&emsp;&emsp;{item.facebook ? item.facebook.split(",").map(x => (<Link key={x} target="_blank" href={"https://www.facebook.com/" + x}>{x}</Link>)) : "/"}</Typography>
					<Typography variant="body1" gutterBottom><InstagramIcon className='icon_instagram' />&emsp;&emsp;{item.instagram ? item.instagram.split(",").map(x => (<Link key={x} target="_blank" href={"https://www.instagram.com/" + x}>{x}</Link>)) : "/"}</Typography>
					<Typography variant="body1" gutterBottom>MeWe&nbsp;&nbsp;{item.mewe ? item.mewe.split(",").map(x => (<Link key={x} target="_blank" href={x}>{x}</Link>)) : "/"}</Typography>
				</div> 
			</DialogContent>
		</BootstrapDialog>
	);
}
